import { Users } from "lucide-react";
import { LEADERSHIP_THEMES } from "@/data/content";
import { Reveal, ChapterBadge } from "@/components/Reveal";

export default function Leadership() {
  return (
    <section data-testid="leadership-section" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ChapterBadge number="07" label="Leadership Matrix" />

        <div className="mt-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-charcoal-900 leading-[1.1]">
              Leading creative teams. Building <em className="italic text-copper-600">better workflows.</em>
            </h2>
            <p className="mt-6 text-base sm:text-lg text-charcoal-600 leading-relaxed">
              At Sri Sri Tattva and beyond, I lead and coordinate multi-disciplinary creative
              teams — directing work, allocating projects, resolving conflicts and keeping
              quality high across every deliverable. Leadership, for me, is equal parts
              direction and discipline.
            </p>
            <div className="mt-8 inline-flex items-center gap-4 bg-surface-white border border-charcoal-900/10 rounded-2xl px-6 py-5">
              <span className="w-11 h-11 rounded-full bg-copper-100 border border-copper-600/20 flex items-center justify-center text-copper-600">
                <Users className="w-5 h-5" />
              </span>
              <div>
                <p className="font-serif text-2xl text-charcoal-900 leading-none">Multi-Disciplinary Teams</p>
                <p className="mt-1 text-xs text-charcoal-500">Designers, editors &amp; videographers — led and coordinated end to end</p>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-2 gap-3.5 content-start">
            {LEADERSHIP_THEMES.map((theme, i) => (
              <Reveal key={theme} delay={Math.min(i * 0.04, 0.3)}>
                <div
                  data-testid={`leadership-theme-${i}`}
                  className="group flex items-center gap-3 bg-surface-white border border-charcoal-900/10 rounded-xl px-4 py-4 hover:border-copper-600/40 hover:-translate-y-0.5 transition-[transform,border-color] duration-300"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-copper-600/60 shrink-0" aria-hidden="true" />
                  <span className="text-sm font-medium text-charcoal-800">{theme}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
